import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const singleUserChatApi = createAsyncThunk("singleUserChat", async (_id) => {
  const response = await axiosInstance.get(`/chatSingleData/${_id}`);
  return response.data;
});

const singleUserChatSlice = createSlice({
  name: "singleUserChat",
  initialState: {
    singleUserChat: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(singleUserChatApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(singleUserChatApi.fulfilled, (state, action) => {
        state.singleUserChat = action.payload;
        state.loading = false;
      })
      .addCase(singleUserChatApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default singleUserChatSlice.reducer;
